// Turning a preference into a painted theme.
//
// Kept apart from the React layer so the resolve step can be unit-tested on its
// own, and so anything outside the tree (a non-React entry point) can reach the
// same behaviour.

import {
    THEME_DARK,
    THEME_LIGHT,
    THEME_ATTRIBUTE,
} from "./themeConstants";

/**
 * Narrow any value to a theme that can actually be painted. Only the two names
 * pass; anything else — a hand-edited storage value, a name from an older
 * release that still had "system" in it — lands on light.
 */
export const resolveTheme = (theme) =>
    theme === THEME_DARK ? THEME_DARK : THEME_LIGHT;

/**
 * Stamp the resolved theme onto <html>, which is what every stylesheet keys
 * off. Also updates the address-bar/status-bar tint on mobile, which otherwise
 * stays on the light value baked into index.html.
 */
export const applyResolvedTheme = (resolved) => {
    if (typeof document === "undefined") {return;}

    const root = document.documentElement;
    if (!root) {return;}

    root.setAttribute(THEME_ATTRIBUTE, resolved);

    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
        meta.setAttribute(
            "content",
            resolved === THEME_DARK ? "#0A0A0F" : "#001871",
        );
    }
};

/** The preference that follows this one when the user hits the toggle. */
export const getNextTheme = (theme) =>
    resolveTheme(theme) === THEME_DARK ? THEME_LIGHT : THEME_DARK;

export { THEME_DARK, THEME_LIGHT };
